// @ts-nocheck
import axios from 'axios'
export class ApiBase<B, R, E> {
    constructor(body?: B) {
        this.body = body;
    }
    url: string = ''
    method: string = 'get'
    body: B
    result !: R
    exception !: E
    headers: any
    fetch() {
        return Apifetch(this)
    }
}
/**
 * fetch请求数据
 * @param api 
 * @param ctx koa.Context对象，如果有ctx参数，表示在node端请求
 */
export async function Apifetch<A extends ApiBase>(api: A): Promise<A> {
    var { url, method, body } = api;
    // var args : any = [api.url];
    var req: any = {
        url,
        method,
    };
    req.headers = {}
    if (api.headers) {
        req.headers = api.headers;
    }
    if (api.method.toLowerCase() === 'post') {
        req.data = body;
    } else {
        if (api.body && Object.keys(api.body).length > 0) {
            req.url += (req.url.indexOf('?') === -1 ? '?' : '&') + Object.keys(api.body).map(field => `${field}=${api.body[field]}`).join('&')
        }
    }
    req.url += (req.url.indexOf('?') > -1 ? '&' : '?') + `t=${new Date().valueOf()}`
    try {
        var result = await axios(req)
        api.result = result.data;
    } catch(e) {
        console.log(e);
    }
    return api;
}